// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"f685f58a","364":"d3d1f198","614":"4fe7be87"}[chunkId] + ".chunk.js";
};